class AuradellePhotoUpload extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    this.input = this.querySelector('input');
    this.status = this.querySelector('.auradelle-upload__status');
    this.error = this.querySelector('.auradelle-upload__error');
    this.preview = this.querySelector('img');
    this.input.addEventListener('change', () => this.update());
    this.input.addEventListener('invalid', () => {
      this.showError(this.input.validationMessage || this.dataset.required);
    });
    this.update();
  }
  disconnectedCallback() {
    if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
  }
  showError(message) {
    this.error.textContent = message;
    this.error.hidden = false;
    this.input.setAttribute('aria-invalid', 'true');
  }
  update() {
    if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
    this.preview.hidden = true;
    this.preview.removeAttribute('src');
    this.error.hidden = true;
    this.input.removeAttribute('aria-invalid');
    this.input.setCustomValidity('');
    const file = this.input.files?.[0];
    this.status.textContent = this.dataset.empty;
    if (!file) {
      if (this.input.required) this.input.setCustomValidity(this.dataset.required);
      return;
    }
    let message = '';
    if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) message = this.dataset.invalidType;
    else if (file.size > 10 * 1024 * 1024) message = this.dataset.tooLarge;
    if (message) {
      this.input.setCustomValidity(message);
      this.showError(message);
      return;
    }
    this.previewUrl = URL.createObjectURL(file);
    this.preview.src = this.previewUrl;
    this.preview.hidden = false;
    this.status.textContent = `${this.dataset.selected}: ${file.name}`;
  }
}
if (!customElements.get('auradelle-photo-upload')) customElements.define('auradelle-photo-upload', AuradellePhotoUpload);
